import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../i18n/content";
import { Reveal, Overline } from "../components/Reveal";
import { PageIntro } from "../components/PageIntro";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { FinalCTA } from "../components/FinalCTA";

export default function About() {
  const { t } = useLang();
  const chapters = t("about.chapters");
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <>
      <PageIntro overline={t("about.overline")} title={t("about.title")} testId="about-intro" />

      <section className="bg-cream pb-24 lg:pb-32" data-testid="about-body">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-[1fr_1fr] lg:gap-20 lg:px-10">
          <Reveal>
            <div ref={ref} className="relative overflow-hidden rounded-2xl" style={{ aspectRatio: "3 / 4" }}>
              <motion.img style={{ y, scale: 1.15 }} src={IMAGES.portraitAbout} alt="Shakti Love Music DEEJAY portrait" className="h-full w-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.1} className="flex flex-col justify-center">
            <div className="space-y-6 text-lg leading-relaxed text-charcoal/75">
              <p className="first-letter:float-left first-letter:mr-3 first-letter:font-serif first-letter:text-7xl first-letter:leading-[0.8] first-letter:text-terracotta">
                {t("about.p1")}
              </p>
              <p>{t("about.p2")}</p>
              <p>{t("about.p3")}</p>
            </div>
          </Reveal>
        </div>
      </section>

      <EditorialMarquee items={t("marquee")} testId="about-marquee" />

      <section className="bg-sand/40 py-24 lg:py-32" data-testid="about-manifesto">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <Reveal>
            <Overline>{t("about.manifestoTitle")}</Overline>
          </Reveal>
          <div className="mt-14 space-y-px">
            {chapters.map((c, i) => (
              <Reveal key={c.t} delay={i * 0.08}>
                <div className="grid grid-cols-1 gap-4 border-t border-border py-10 md:grid-cols-[120px_1fr_1.4fr] md:gap-10" data-testid={`manifesto-${i}`}>
                  <span className="font-serif text-6xl font-light leading-none text-terracotta/50">0{i + 1}</span>
                  <h3 className="font-serif text-3xl text-charcoal">{c.t}</h3>
                  <p className="max-w-lg text-lg leading-relaxed text-charcoal/70">{c.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </>
  );
}
